import React, { Component } from "react";
import { Link as RouterLink, Redirect } from "react-router-dom";
import { registerUser, loginWithGoogle } from "../_actions/authActions";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { LOGIN, ROOT } from "../_utils/routes";
import axios from "axios";
import FormErrors from "../TldrLogin/FormErrors";
import TldrBase from "../TldrLogin/TldrBase";
import GoogleLogin from "react-google-login";
import { GOOGLE_CLIENT_ID } from "../_actions/endpoints";
import { setErrorMessage } from "../TldrLogin/statelessView";
import queryString from "query-string";
import {
  Alert,
  Box,
  Button,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  Input,
  Link,
  Text,
} from "@chakra-ui/react";
import { withTranslation } from "react-i18next";

class Register extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);
    const planName = queryString.parse(this.props.location.search).plan_name;
    const promoCode = queryString.parse(this.props.location.search).promo_code;
    this.state = {
      email: "",
      company: "",
      password1: "",
      password2: "",
      formErrors: {
        email: "",
        company: "",
        password1: "",
        password2: "",
      },
      emailValid: false,
      companyValid: false,
      password1Valid: false,
      password2Valid: false,
      formValid: false,
      googleLoginErrors: "",
      loading: false,
      planName: planName,
      promoCode: promoCode,
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onChange(e) {
    this.validateField(e.target.name, e.target.value);
    this.setState({ [e.target.name]: e.target.value });
  }

  UNSAFE_componentWillMount() {
    if (this.state.planName) {
      localStorage.setItem("planName", this.state.planName);
    } else {
      localStorage.removeItem("planName");
    }

    if (this.state.promoCode) {
      localStorage.setItem("promoCode", this.state.promoCode);
    } else {
      localStorage.removeItem("promoCode");
    }
  }
  validateForm() {
    this.setState({
      formValid:
        this.state.emailValid &&
        this.state.password1Valid &&
        this.state.password2Valid &&
        this.state.companyValid,
    });
  }

  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let emailValid = this.state.emailValid;
    let companyValid = this.state.companyValid;
    let password1Valid = this.state.password1Valid;
    let password2Valid = this.state.password2Valid;
    switch (fieldName) {
      case "email":
        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        fieldValidationErrors.email = emailValid
          ? ""
          : this.props.t("register.email_error");
        break;
      case "company":
        companyValid = value.length > 0;
        fieldValidationErrors.company = companyValid
          ? ""
          : this.props.t("register.company_error");
        break;
      case "password1":
        password1Valid = value.length >= 8;
        fieldValidationErrors.password1 = password1Valid
          ? ""
          : this.props.t("register.password_error");
        break;
      case "password2":
        password2Valid = value === this.state.password1;
        fieldValidationErrors.password2 = password2Valid
          ? ""
          : this.props.t("register.confirm_password_error");
        break;
      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        emailValid: emailValid,
        companyValid: companyValid,
        password1Valid: password1Valid,
        password2Valid: password2Valid,
      },
      this.validateForm
    );
  }

  googleResponse = (response, e) => {
    const tokenJSON = { access_token: response.accessToken };
    this.props.loginWithGoogle(tokenJSON, { ...this.props }, "signUp");
  };
  onFailure = (error) => {
    let errorMessage = setErrorMessage(error);
    this.setState({
      loading: false,
      googleLoginErrors: errorMessage,
    });
  };

  errorClass(error) {
    return error.length === 0 ? "" : "has-error is-invalid";
  }

  validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(String(email).toLowerCase()))
      setTimeout(
        () => this.setErrors({ email: this.props.t("register.email_error") }),
        800
      );
    else this.setErrors({ email: "" });
  };

  setErrors = (error) =>
    this.setState({
      formErrors: { ...this.state.formErrors, ...error },
    });

  onSubmit(e) {
    e.preventDefault();
    if (this.state.loading) {
      return;
    }
    this.setState({
      loading: true,
    });
    let newUser = {
      email: this.state.email,
      company: this.state.company,
      password1: this.state.password1,
      password2: this.state.password2,
    };

    if (this.state.planName) newUser.plan_name = this.state.planName;
    if (this.state.promoCode) newUser.promo_code = this.state.promoCode;

    this.props
      .registerUser(newUser, { ...this.props }, this.signal.token)
      .then(() => {
        this.setState({
          ...this.state,
          loading: false,
        });
      });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors, loading: false });
    }
  }

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }

  render() {
    const { t } = this.props;
    const { googleLoginErrors, loading } = this.state;
    const { from } = this.props.location.state || { from: { pathname: "/" } };
    if (this.props.auth.isAuthenticated) {
      if (localStorage.getItem("path")) {
        return <Redirect to={localStorage.getItem("path")}/>;
      }
      return <Redirect to={from ? from : ROOT} />;
    }
    const signUpError =
      !Object.keys(this.props.errors).includes("email") &&
      !Object.keys(this.props.errors).includes("password1") &&
      googleLoginErrors.length === 0 ? (
        <div></div>
      ) : (
        <Alert status='error'>
          <FormErrors
            formErrors={
              googleLoginErrors.length > 0
                ? googleLoginErrors
                : this.props.errors
            }
          />
        </Alert>
      );

    return (
      <TldrBase
        heading={t("register.welcome")}
        showBackgroundImage
        wrapperClassName="register-wrapper"
      >
        <Box className="social-buttons" mb={4}>
          <GoogleLogin
            buttonText={t("register.google")}
            clientId={GOOGLE_CLIENT_ID}
            onSuccess={this.googleResponse}
            onFailure={this.onFailure}
            cookiePolicy={"single_host_origin"}
            className="social-btn-google"
            theme="dark"
          />
        </Box>

        <Flex mt={2} align="center">
          <Divider mr={2} />
          <Text as={"p"} mt="0">
            {t("login.or")}
          </Text>
          <Divider ml={2} />
        </Flex>

        {signUpError}
        <form onSubmit={this.onSubmit}>
          <FormControl mb={3} isInvalid={this.state.formErrors.email}>
            <Input
              fontSize={"inherit"}
              size={"lg"}
              type="email"
              name="email"
              placeholder={t("register.email")}
              onBlur={(e) => this.validateEmail(e.target.value)}
              value={this.email}
              onChange={this.onChange}
            />
            <FormErrorMessage>{this.state.formErrors.email}</FormErrorMessage>
          </FormControl>

          <FormControl mb={3} isInvalid={this.state.formErrors.company}>
            <Input
              fontSize={"inherit"}
              size={"lg"}
              type="text"
              name="company"
              placeholder={t("register.company")}
              value={this.company}
              onChange={this.onChange}
            />
            <FormErrorMessage>{this.state.formErrors.company}</FormErrorMessage>
          </FormControl>

          <FormControl mb={3} isInvalid={this.state.formErrors.password1}>
            <Input
              fontSize={"inherit"}
              size={"lg"}
              type="password"
              name="password1"
              placeholder={t("register.password")}
              value={this.password1}
              onChange={this.onChange}
            />
            <FormErrorMessage>
              {this.state.formErrors.password1}
            </FormErrorMessage>
          </FormControl>

          <FormControl mb={3} isInvalid={this.state.formErrors.password2}>
            <Input
              fontSize={"inherit"}
              size={"lg"}
              type="password"
              name="password2"
              placeholder={t("register.confirm_password")}
              value={this.password2}
              onChange={this.onChange}
            />
            <FormErrorMessage>
              {this.state.formErrors.password2}
            </FormErrorMessage>
          </FormControl>

          <Box mb={1} textAlign="end">
            <Button
              type="submit"
              size="lg"
              variant="solid"
              disabled={!this.state.formValid || loading}
              isLoading={loading}
            >
              {t("register.signup")}
            </Button>
            <p style={{ color: "red" }}>{this.state.formErrors.checked}</p>
          </Box>
        </form>

        <Box mt={4} textAlign="end">
          <label>
            {t("register.registered")}{" "}
            <Link as={RouterLink} to={LOGIN}>
              {t("register.login")}
            </Link>
          </label>
          <label>
            {t("register.accept")}{" "}
            <Link
              target="_blank"
              rel="noopener noreferrer"
              href="https://simplified.co/termsofservice"
            >
              {t("register.tnc")}
            </Link>
          </label>
        </Box>
      </TldrBase>
    );
  }
}

Register.prototypes = {
  registerUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps, { registerUser, loginWithGoogle })(
  withRouter(withTranslation(["auth"])(Register))
);
